import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'day8-ui';
import { IoIosGlobe } from "@react-icons/all-files/io/IoIosGlobe";
import {
  getSelectedFilters, isFilterSelected, onFilterSelect
} from '../../../../helpers/filter';
import { FILTERS } from '../../../../constants';
import { useDispatch } from 'react-redux';

const Destination = props => {
  const dispatch = useDispatch();
  const destinationOptions = props.destinations.map(({ id, name }) => ({
    value: id,
    label: name
  }));
  const selectedFilterText = getSelectedFilters(props.location)[FILTERS.DESTINATION].map(itemValue => destinationOptions.find(i => +i.value === +itemValue)?.label).join(', ');
  // const handleClearFilter = () => {
  //   clearFilter(props.dispatch, props.filterAction, FILTERS.DESTINATION_CONFIRM);
  //   clearFilter(props.dispatch, props.filterAction, FILTERS.DESTINATION);
  // };
  return props.mobile ? (
    <div className={props.className}>
      <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Destination</h3>
      <div className='dui-flex dui-flex-wrap dui-gap-4 dui-mt-4'>
        {destinationOptions.map(item => (
          <Button key={JSON.stringify(item)} buttonType={isFilterSelected(props.location, FILTERS.DESTINATION, item.value) ? 'FILTER_ACTIVE' : 'FILTER'} onClick={() => onFilterSelect(props.location, dispatch, props.filterAction, FILTERS.DESTINATION, item.value)}>{item.label}</Button>
        ))}
      </div>
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<IoIosGlobe />}>{selectedFilterText || 'Destination'}</Button>;
};
Destination.propTypes = {
  destinations: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  setPage: PropTypes.func,
  mobile: PropTypes.bool,
  renderFilterMenuButton: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  className: PropTypes.string,
  filterAction: PropTypes.func.isRequired
};
export default Destination;
